import { render, staticRenderFns } from "./story-modal.vue?vue&type=template&id=a1548102&scoped=true&"
import script from "./story-modal.vue?vue&type=script&lang=js&"
export * from "./story-modal.vue?vue&type=script&lang=js&"
import style0 from "./story-modal.vue?vue&type=style&index=0&id=a1548102&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1548102",
  null
  
)

export default component.exports